<template>
    <modal id="salary-sheet-edit-modal"
           size="large"
           v-model="showModal"
           :title="$fieldTitle('edit', 'salary', true)"
           @submit="submitData" :loading="loading"
           :preloader="preloader">

        <div class="d-flex justify-content-center mb-primary">
            <div class="text-center">
                <img :src="logo" alt="logo" class="radius-5" style="max-height: 100px; max-width: 150px;"/>
            </div>
        </div>

        <div class="d-flex justify-content-between mb-primary py-primary">
            <div class="">
                <app-user-media
                    :row-data="rowData.employee"
                    :value="rowData.employee.profile_picture"
                />
            </div>
            <div>
                <p class="m-0">{{ this.$t('month') }} : <span class="text-info">{{ formData.month }}</span></p>
                <p class="m-0">{{ this.$t('created_at') }} : {{ formatDateToLocal(formData.created_at) }}</p>
            </div>
            <div>
                <p class="m-0">{{ this.$t('designation') }} :
                    {{ rowData.employee.designation ? rowData.employee.designation.name : 'None' }}</p>
                <p class="m-0">{{ this.$t('department') }} :
                    {{ rowData.employee.department ? rowData.employee.department.name : 'None' }}</p>
            </div>
        </div>

        <form ref="form" :data-url="selectedUrl" @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-12">
                    <app-form-group
                        type="number"
                        :label="$t('base_salary')"
                        :placeholder="$placeholder('base_salary')"
                        v-model="formData.base_salary"
                        :error-message="$errorMessage(errors, 'base_salary')">
                    </app-form-group>
                </div>
                <!--
                <div class="col-md-12 mt-primary">
                    <div class="d-flex justify-content-between border-bottom">
                        <h6>{{ this.$t('basic_salary') }}</h6>
                        <h6>{{ formatCurrency(numberFormatter(Number(formData.base_salary))) }}</h6>
                    </div>
                </div>
                -->
                <div class="col-md-12">
                    <div class="mb-primary mt-primary">
                        <div class="d-flex justify-content-between border-bottom mb-2">
                            <h6>{{ this.$t('beneficiary') }}</h6>
                        </div>

                        <div class="text-muted">
                            <app-form-group
                                type="multi-select"
                                page="page"
                                :label="$t('information')"
                                list-value-field="name"
                                v-model="formData.information"
                                :list="information"
                                @deletedId="removeInformationId"
                                @addedId="addInformationId"
                            />
                            <div v-if="formData.information.length && beneficiaries.length">
                                <div class="row" v-for="(information, index) in selectedInformation" :key="index">
                                    <div class="col-3"></div>
                                    <div class="col-7 form-group">
                                        <div class="row align-items-center">
                                            <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
                                                <label class="text-left d-block mb-lg-0">
                                                    {{ information.name }}
                                                </label>
                                            </div>
                                            <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
                                                <app-input
                                                    type="number"
                                                    v-model="formData.informationValues[information.id]"
                                                    :placeholder="'value'"
                                                    :required="true"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-1 pl-0 ml-0">
                                        <a href="#" @click.prevent="removeSelectedInformation(information.id)">
                                            <app-icon name="trash" class="text-primary mt-2" width="22"/>
                                        </a>
                                    </div>
                                </div>
                                <div class="row mb-primary" v-if="errors.informationValues">
                                    <div class="col-3"></div>
                                    <div class="col-9">
                                        <small class="text-warning">{{ errors.informationValues[0] }}</small>
                                    </div>
                                </div>
                            </div>

                            <app-form-group
                                type="multi-select"
                                page="page"
                                :label="$t('allowance')"
                                list-value-field="name"
                                v-model="formData.allowances"
                                :list="allowances"
                                @deletedId="removeAllowanceId"
                                @addedId="addAllowanceId"
                            />
                            <div v-if="formData.allowances.length && beneficiaries.length">
                                <div class="row" v-for="(allowance, index) in selectedAllowances" :key="index">
                                    <div class="col-3"></div>
                                    <div class="col-7 form-group">
                                        <div class="row align-items-center">
                                            <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
                                                <label class="text-left d-block mb-lg-0">
                                                    {{ allowance.name }}
                                                </label>
                                            </div>
                                            <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
                                                <app-input
                                                    type="number"
                                                    v-model="formData.allowanceValues[allowance.id]"
                                                    :placeholder="'value'"
                                                    :required="true"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-1 pl-0 ml-0">
                                        <a href="#" @click.prevent="removeSelectedAllowance(allowance.id)">
                                            <app-icon name="trash" class="text-primary mt-2" width="22"/>
                                        </a>
                                    </div>
                                </div>
                                <div class="row mb-primary" v-if="errors.allowanceValues">
                                    <div class="col-3"></div>
                                    <div class="col-9">
                                        <small class="text-warning">{{ errors.allowanceValues[0] }}</small>
                                    </div>
                                </div>
                            </div>

                            <app-form-group
                                type="multi-select"
                                page="page"
                                :label="$t('deduction')"
                                list-value-field="name"
                                v-model="formData.deductions"
                                :list="deductions"
                                @deletedId="removeDeductionId"
                                @addedId="addDeductionId"
                            />
                            <div v-if="formData.deductions.length && beneficiaries.length">
                                <div class="row" v-for="(deduction, index) in selectedDeductions" :key="index">
                                    <div class="col-3"></div>
                                    <div class="col-7 form-group">
                                        <div class="row align-items-center">
                                            <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
                                                <label class="text-left d-block mb-lg-0">
                                                    {{ deduction.name }}
                                                </label>
                                            </div>
                                            <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
                                                <app-input
                                                    type="number"
                                                    v-model="formData.deductionValues[deduction.id]"
                                                    :placeholder="'value'"
                                                    :required="true"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-1 pl-0 ml-0">
                                        <a href="#" @click.prevent="removeSelectedDeduction(deduction.id)">
                                            <app-icon name="trash" class="text-primary mt-2" width="22"/>
                                        </a>
                                    </div>
                                </div>
                                <div class="row" v-if="errors.deductionValues">
                                    <div class="col-3"></div>
                                    <div class="col-9">
                                        <small class="text-warning">{{ errors.deductionValues[0] }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between border-bottom mt-2">
                            <p class="m-0">{{ this.$t('total_information') }}</p>
                            <p class="m-0">{{ numberFormatter(totalInformation) }}</p>
                        </div>

                        <div class="d-flex justify-content-between border-bottom mt-2">
                            <p class="m-0">{{ this.$t('total_allowance') }}</p>
                            <p class="m-0">{{ formatCurrency(numberFormatter(totalAllowances)) }}</p>
                        </div>

                        <div class="d-flex justify-content-between border-bottom mt-2">
                            <p class="m-0">{{ this.$t('total_deduction') }}</p>
                            <p class="m-0">{{ formatCurrency(numberFormatter(totalDeductions)) }}</p>
                        </div>

                        <div class="d-flex justify-content-between border-bottom mb-primary mt-3">
                            <h6>{{ this.$t('beneficiary_amount') }}</h6>
                            <h6>{{ formatCurrency(numberFormatter(totalBeneficiary)) }}</h6>
                        </div>

                        <div class="d-flex justify-content-between border-bottom mb-primary">
                            <h6>{{ this.$t('net_payable_salary') }}</h6>
                            <h6>{{ formatCurrency(numberFormatter(formData.net_salary)) }}</h6>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <app-form-group
                        :label="$t('attachment')"
                        type="file"
                        v-model="formData.attachment"
                        :placeholder="$placeholder('attachment', '')"
                        :file-label="$placeholder('attachment', '')"
                        :error-message="$errorMessage(errors, 'attachment')"
                    >
                        <template slot="suggestion">
                            <small class="text-muted font-italic mt-3 d-inline-block">
                                {{ $t('document_recommendation') }}
                            </small>
                        </template>
                    </app-form-group>

                    <app-form-group
                        type="textarea"
                        :label="$t('note')"
                        :placeholder="$textAreaPlaceHolder('note')"
                        v-model="formData.note"
                        :text-area-rows="4"
                        :error-message="$errorMessage(errors, 'note')">
                    </app-form-group>
                </div>
                <div class="col-md-12">
                    <app-form-group
                        type="switch"
                        v-model="formData.status"
                        :label="$t('status')"
                        :error-message="$errorMessage(errors, 'status')"
                    />
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";
import {axiosGet, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import {formatDateToLocal} from "../../../../common/Helper/Support/DateTimeHelper";
import {formatCurrency, numberFormatter} from "../../../../common/Helper/Support/SettingsHelper";

export default {
    name  : "SalarySheetEditModal",
    mixins: [FormHelperMixins, ModalMixin],
    props : {
        rowData: {},
    },
    data() {
        return {
            TENANT_BASE_URL,
            beneficiaries      : [],
            selectedAllowances : [],
            selectedInformation: [],
            selectedDeductions : [],
            formData           : {
                information      : [],
                informationValues: {},
                allowances       : [],
                allowanceValues  : {},
                deductions       : [],
                deductionValues  : {},
                net_salary       : 0,
            },
        }
    },
    created() {
        this.getBeneficiaries();
    },
    computed: {
        logo() {
            return this.$store.state.settings.tenant_logo
                   ? urlGenerator(this.$store.state.settings.tenant_logo)
                   : urlGenerator('/images/logo/default-logo.png')
        },
        information() {
            return this.beneficiaries.filter(benefit => benefit.type === 'information');
        },
        allowances() {
            return this.beneficiaries.filter(benefit => benefit.type === 'allowance');
        },
        deductions() {
            return this.beneficiaries.filter(benefit => benefit.type === 'deduction');
        },
        totalBeneficiary() {
            return Number(this.totalAllowances - this.totalDeductions);
        },
        totalInformation() {
            let total = 0;
            this.formData.information.forEach(id => {
                const informationValue = this.formData.informationValues[id] ? Number(this.formData.informationValues[id]) : 0;
                total += informationValue;
            })
            return total;
        },
        totalAllowances() {
            let total = 0;
            this.formData.allowances.forEach(id => {
                const allowanceValue = this.formData.allowanceValues[id] ? Number(this.formData.allowanceValues[id]) : 0;
                total += allowanceValue;
            })
            return total;
        },
        totalDeductions() {
            let total = 0;
            this.formData.deductions.forEach(id => {
                const deductionValue = this.formData.deductionValues[id] ? Number(this.formData.deductionValues[id]) : 0;
                total += deductionValue;
            })
            return total;
        },
    },
    methods : {
        numberFormatter,
        formatCurrency,
        formatDateToLocal,
        /* Information */
        addInformationId(value) {
            const information = this.beneficiaries.find(item => item.id === value);
            this.selectedInformation.push(information)
        },
        removeInformationId(value) {
            const index = this.selectedInformation.findIndex(item => item.id === value);
            this.selectedInformation.splice(index, 1);
            this.$delete(this.formData.informationValues, value);
        },
        removeSelectedInformation(value) {
            const indexInformation = this.formData.information.findIndex(id => id === value);
            const index            = this.selectedInformation.findIndex(item => item.id === value);
            this.selectedInformation.splice(index, 1);
            this.formData.information.splice(indexInformation, 1);
            this.$delete(this.formData.informationValues, value);
        },
        /* Allowance */
        addAllowanceId(value) {
            const allowance = this.beneficiaries.find(item => item.id === value);
            this.selectedAllowances.push(allowance)
        },
        removeAllowanceId(value) {
            const index = this.selectedAllowances.findIndex(item => item.id === value);
            this.selectedAllowances.splice(index, 1);
            this.$delete(this.formData.allowanceValues, value);
        },
        removeSelectedAllowance(value) {
            const indexAllowance = this.formData.allowances.findIndex(id => id === value);
            const index          = this.selectedAllowances.findIndex(item => item.id === value);
            this.selectedAllowances.splice(index, 1);
            this.formData.allowances.splice(indexAllowance, 1);
            this.$delete(this.formData.allowanceValues, value);
        },
        /* Deduction */
        addDeductionId(value) {
            const allowance = this.beneficiaries.find(item => item.id === value);
            this.selectedDeductions.push(allowance)
        },
        removeDeductionId(value) {
            const index = this.selectedDeductions.findIndex(item => item.id === value);
            this.selectedDeductions.splice(index, 1);
            this.$delete(this.formData.deductionValues, value);
        },
        removeSelectedDeduction(value) {
            const indexDeduction = this.formData.deductions.findIndex(id => id === value);
            const index          = this.selectedDeductions.findIndex(item => item.id === value);
            this.selectedDeductions.splice(index, 1);
            this.formData.deductions.splice(indexDeduction, 1);
            this.$delete(this.formData.deductionValues, value);
        },
        getBeneficiaries() {
            this.preloader = true;
            axiosGet(this.apiUrl.SELECTABLE_BENEFICIARY_BADGE).then(({data}) => {
                this.beneficiaries = data
            }).finally(() => {
                this.preloader = false;
            })
        },
        submitData() {
            this.loading   = true
            const url      = this.$refs.form.dataset["url"];
            const formData = new FormData;

            formData.set('base_salary', this.formData.base_salary)
            formData.set('attachment', this.formData.attachment)
            formData.set('status', this.formData.status)
            formData.set('note', this.formData.note)

            if (this.formData.informationValues) {
                formData.set('informationValues', JSON.stringify(this.formData.informationValues))
            }
            if (this.formData.allowanceValues) {
                formData.set('allowanceValues', JSON.stringify(this.formData.allowanceValues))
            }
            if (this.formData.deductionValues) {
                formData.set('deductionValues', JSON.stringify(this.formData.deductionValues))
            }

            formData.append('_method', 'PATCH');

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#salary-sheet-edit-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'salary-sheet-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader           = false;
            this.formData            = response.data;
            this.formData.net_salary = Number(this.formData.base_salary)
            this.selectedInformation = []
            this.selectedAllowances  = []
            this.selectedDeductions  = []

            if (this.formData.items.length > 0) {
                const informationData = this.formData.items.filter(benefit => benefit.type === 'information');
                const allowancesData  = this.formData.items.filter(benefit => benefit.type === 'allowance');
                const deductionsData  = this.formData.items.filter(benefit => benefit.type === 'deduction');

                informationData.forEach(item => {
                    this.$set(this.formData.informationValues, item.salary_item_id, item.value);
                    this.formData.information.push(item.salary_item_id)
                    this.selectedInformation.push({
                        id  : item.salary_item_id,
                        name: item.name,
                    })
                })
                allowancesData.forEach(item => {
                    this.$set(this.formData.allowanceValues, item.salary_item_id, item.value);
                    this.formData.allowances.push(item.salary_item_id)
                    this.selectedAllowances.push({
                        id  : item.salary_item_id,
                        name: item.name,
                    })
                    this.formData.net_salary += Number(item.value)
                })
                deductionsData.forEach(item => {
                    this.$set(this.formData.deductionValues, item.salary_item_id, item.value);
                    this.formData.deductions.push(item.salary_item_id)
                    this.formData.net_salary -= Number(item.value)
                    this.selectedDeductions.push({
                        id  : item.salary_item_id,
                        name: item.name,
                    })
                })
            }
        },
    },
    watch   : {
        totalBeneficiary      : {
            handler: function (totalBeneficiary) {
                this.formData.net_salary = Number(this.formData.base_salary) + totalBeneficiary
            },
        },
        'formData.base_salary': {
            handler: function (base_salary) {
                this.formData.net_salary = Number(base_salary) + this.totalBeneficiary
            },
        }
    }
}
</script>

